import { Link } from 'react-router-dom';
import { Percent } from 'lucide-react';

import { useProcessingFee } from '@/hooks/useProcessingFee';
import { dayLabel, ratePercent } from '@/types/advisor-billing';

export default function ProcessingFeeBanner() {
  const { data } = useProcessingFee();
  const coming = data?.upcoming;
  if (!coming) return null;

  return (
    <div
      className="mb-4 flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950"
      data-testid="processing-fee-banner"
    >
      <Percent className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
      <span className="flex-1">
        <strong>
          From {dayLabel(coming.effective_from)} the processing fee is{' '}
          {ratePercent(coming.rate_percent)}.
        </strong>{' '}
        It is what BitSwan keeps out of your share of invoices billed through
        BitSwan, and today it is {ratePercent(data.rate_percent)}. Your clients
        pay the same as before, and contracts you invoice directly are not
        affected.
      </span>
      <Link
        to="/advisor/billing"
        className="shrink-0 font-medium underline underline-offset-2"
        data-testid="processing-fee-banner-link"
      >
        Your billing
      </Link>
    </div>
  );
}
